<template>
  <TypeAhead
    v-model="data"
    :id="idInput"
    :srcImgLoading="srcImgLoading"
    :classes="classes"
    :placeholder="placeholder"
    :src="urlGetAutocomplete"
    :getResponse="getResponse"
    :selectFirst="selectFirst"
    :limit="parseInt(limit)"
    :queryParamName="queryParamName"
    :minChars="parseInt(minChars)"
    :delayTime="parseInt(delayTime)"
    :onHit="onHit"
    :highlighting="highlighting"
    :render="render"
    :fetch="fetch"
    :clean="cleanVia"
  ></TypeAhead>
</template>
<script>
import axios from "axios";
import TypeAhead from "../templatesComponents/VueSaxTypeAheadTemplate";

// const DEFAULT_TOKEN = "b5abb242-39a3-4179-a6c3-8eaf4269ea85";

export default {
  components: {
    TypeAhead,
  },
  data() {
    return {
      data: "",
      access_token: process.env.VUE_APP_TOKEN_APIS,
      store_ubigeo: this.$store.getters.store_getUbigeo,
      urlGetAutocomplete: "",
      selectFirst: true,
      srcImgLoading: "@/assets/images/loading-two.gif",
      limit: 7,
      queryParamName: ":search",
      minChars: 2,
      delayTime: 0,
      placeholder: "Via ejm: Arequipa",
      idInput: "idInputVia",
      classes: "typeahead searchVia",
    };
  },
  created() {
    this.urlGetAutocomplete =
      process.env.VUE_APP_ROUTES +
      "&key=" +
      app.access_token +
      "&localityId=" +
      this.ubigeo;
  },
  computed: {
    ubigeo() {
      return this.$store.getters.store_getUbigeo;
    },
  },
  mounted() {
    let app = this;
    if (app.checkLogin()) {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      app.access_token = tokenData.data.access_token;
      //app.urlGetAutocomplete = process.env.VUE_APP_URL_VIA + this.ubigeo+'/via?access_token='+app.access_token+'&search=:search';
      //console.log(app.urlGetAutocomplete);
    }

    this.$store.watch(this.$store.getters.store_getUbigeo, (ubigeo) => {
      app.store_ubigeo = ubigeo;

      app.urlGetAutocomplete =
        process.env.VUE_APP_ROUTES +
        "&key=" +
        app.access_token +
        "&locality_id=" +
        ubigeo;

      /*if(!ubigeo){
          app.store_ubigeo=ubigeo;
          app.urlGetAutocomplete = process.env.VUE_APP_URL_VIA + ubigeo+'/via?access_token='+app.access_token+'&search=:search';
      }*/
    });

    this.$store.watch(this.$store.getters.isLoggedIn, (n) => {
      if (!n) {
        app.access_token = process.env.VUE_APP_TOKEN_APIS;
      }
    });
  },

  /*watch:{
    store_ubigeo(ubigeo){
      console.log('WATCH ::: COMPONENT VIA');
      console.log('cambio ubigeo ' + ubigeo);
      this.urlGetAutocomplete = this.urlGetAutocomplete + ubigeo+'/via?access_token='+this.access_token+'&search=:search';
      console.log(this.urlGetAutocomplete);
    }
  },*/

  methods: {
    cleanVia: function () {
      this.$emit("cleanViaEmittion");
    },

    checkLogin() {
      return this.$store.state.isLoggedIn;
    },

    getResponse: function (response) {
      return response.data;
    },

    onHit: function (item, vue, index, event) {
      console.log("onhit");
      console.log(item);

      if (item) {
        event.preventDefault();

        let nameVia = item.name;
        let tipoVia = item.pattern_abbr;

        this.$store.commit("SET_TIPO_VIA_DIRECTION", tipoVia);
        this.$store.commit("SET_VIA_DIRECTION", nameVia);
        //Lanzar evento de seleccion de via
        this.$emit("eventSelectVia");
        vue.query = item.name;
      }
    },

    highlighting: function (item, vue) {
      let value = "";
      if (typeof item === "object") {
        value = item.pattern_abbr + " " + item.name;
      } else {
        value = item;
      }
      return value
        .toString()
        .replace(vue.query.toUpperCase(), `<b>${vue.query.toUpperCase()}</b>`);
    },

    render: function (items, vue) {
      //let newItem = [vue.query, ...items];
      let newItem = [...items];
      return newItem;
    },

    fetch: function (url) {
      return axios.get(url);
    },
  },
};
</script>
<style>
#idInputVia {
  padding-right: 30px;
}

.searchVia {
  font-size: 14px;
}
</style>
